import { Stack } from '@mui/material';
import {
  FlowDurationUnits,
  type FlowHieQueryDocumentsBlock,
  FlowHieQueryDocumentsBlockConfigSchema,
  FlowProducedType,
} from 'flow-schema';

import { HieQueryDocumentsBlockDocumentationMarkdown } from './documentation';
import { BlockDurationField } from '../../ConfigFields/Duration';
import { ParentBlockSelectField } from '../../ConfigFields/SelectField';
import { BlockTextField } from '../../ConfigFields/TextField';
import type { BlockConfigProps } from '../../types';

const PATIENT_SOURCE_HELPER_TEXT = `Select which upstream block to pull Patient data from.`;

function FormFields() {
  return (
    <Stack spacing={2}>
      <ParentBlockSelectField
        fieldName="config.patient.sourceBlockName"
        label="Patient Source"
        required
        helperText={PATIENT_SOURCE_HELPER_TEXT}
      />
      <BlockTextField
        fieldName="config.facilityId"
        label="Facility ID"
        required
        helperText="The HIE facility ID"
      />
      <BlockDurationField
        fieldName="config.timeout"
        unitFieldNameSuffix="units"
        required={true}
        allowedUnits={[
          FlowDurationUnits.Hours,
          FlowDurationUnits.Minutes,
          FlowDurationUnits.Seconds,
        ]}
        toggleLabel="Timeout"
        valueLabel="Timeout (fail after duration)"
        valueHelperText="Will fail if block does not complete after duration"
      />
    </Stack>
  );
}

export const hieQueryDocumentsConfig: BlockConfigProps<FlowHieQueryDocumentsBlock['config']> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'hieQueryDocuments',
  defaultConfig: {
    patient: {
      sourceBlockName: '',
      consumesType: FlowProducedType.Patient,
    },
    facilityId: '',
    timeout: {
      value: 10,
      units: FlowDurationUnits.Minutes,
    },
  },
  configFields: {
    schema: FlowHieQueryDocumentsBlockConfigSchema,
    FormFields,
  },
  documentationMarkdown: HieQueryDocumentsBlockDocumentationMarkdown,
};
